export function localRemove(key) {
  localStorage.removeItem(key);
}

export function sessionRemove(key) {
  sessionStorage.removeItem(key);
}

export function localSet(key, value) {
  try {
    let val = typeof value === 'object' ? JSON.stringify(value) : value;
    localStorage.setItem(key, val);
  } catch (e) {
    console.log(e);
    localStorage.setItem(key, value);
  }
}

export function sessionSet(key, value) {
  try {
    let val = typeof value === 'object' ? JSON.stringify(value) : value;
    sessionStorage.setItem(key, val);
  } catch (e) {
    console.log(e);
    sessionStorage.setItem(key, value);
  }
}

export function localGet(key, value) {
  try {
    value = JSON.parse(localStorage.getItem(key));
  } catch (e) {
    value = localStorage.getItem(key);
  }
  return value;
}

export function sessionGet(key, value) {
  try {
    value = JSON.parse(sessionStorage.getItem(key));
  } catch (e) {
    value = sessionStorage.getItem(key);
  }
  return value;
}
